import mexico from "../assets/flags/mexico.png";
import argentina from "../assets/flags/argentina.png";
import paisesBajos from "../assets/flags/paisesBajos.png";
import peru from "../assets/flags/peru.png";

export const interviewList = [
  {
    name: "Selene Casas",
    flag: mexico,
    link: "https://drive.google.com/file/d/15yczP5-E8S6nLXA3CG_OuGE_JkDqcpNv/view?usp=share_link"
  },
  {
    name: "Maria Vlasiou",
    flag: paisesBajos,
    link: "https://drive.google.com/file/d/1EBtBIV_rGAv6rK7gH3TldEMpnsA4TEop/view?usp=share_link"
  },
  {
    name: "María Eugenia Martínez",
    flag: argentina,
    link: "https://drive.google.com/file/d/1xIPxHicBsrx797wealGYO27zEN85aOOJ/view?usp=share_link"
  },
  {
    name: "Roxana López",
    flag: peru,
    link: "https://drive.google.com/file/d/1P3Zk1d2gQPB42gvd0DiDoDmiSg1DKTpr/view?usp=sharing"
  },
  {
    name: "Mucuy-kak Guevara Aguirre",
    flag: mexico,
    link: "https://drive.google.com/file/d/1RRunq55xXQjd6Lb692zgaGWxYsDVu509/view?usp=share_link"
  },
  {
    name: "Casandra Mejía Leal",
    flag: mexico,
    link: "https://drive.google.com/file/d/1hmNrXBYLP2Yihui5DJ1S2FMhIAa26aOD/view?usp=share_link"
  }
];
